export enum LabelPosition {
  PRE = 'pre',
  POST = 'post'
}

export enum DatePickerAlignment {
  Left = 'left',
  Right = 'right'
}
